import FormatListBulleted from '@material-ui/icons/FormatListBulleted';
import FormatListNumbered from '@material-ui/icons/FormatListNumbered';
import FormatAlignLeft from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenter from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRight from '@material-ui/icons/FormatAlignRight';

const controls = {
    unorderedList: {
        icon: FormatListBulleted,
        value: 'unordered-list-item',
    },
    orderedList: {
        icon: FormatListNumbered,
        value: 'ordered-list-item',
    },
    alignLeft: {
        icon: FormatAlignLeft,
        value: 'align-left'
    },
    alignCenter: {
        icon: FormatAlignCenter,
        value: 'align-center'
    },
    alignRight: {
        icon: FormatAlignRight,
        value: 'align-right'
    }
};

export const BLOCK_TYPES = [
    controls.alignLeft,
    controls.alignCenter,
    controls.alignRight,
    controls.unorderedList,
    controls.orderedList
];